/* global localData */
const profileNav = document.querySelector('.user-account-module__nav');

if (profileNav) {
  const inputs = document.querySelectorAll('input');
  const dataContainer = document.querySelector('.user-account-module__right');
  const nameContainer = document.querySelector('.user-account-module__left');
  const toggleActivateForm = (toggleSet = true) => {
    if (!profileNav.querySelector('.is-active')) {
      inputs.forEach((el) => {
        el.toggleAttribute('disabled', toggleSet);
      });
    }
  };
  const toggleCompanySelector = () => {
    const companyInfoCheckbox = document.querySelector('#edit-profile-form .checkbox input');
    const companyInfoFields = document.querySelector('.company-info-fields');

    if (companyInfoCheckbox) {
      companyInfoCheckbox.addEventListener('change', (event) => {
        if (event.currentTarget.checked) {
          toggleHideClass(companyInfoFields, false);
        } else {
          toggleHideClass(companyInfoFields, true);
        }
      });
    }
  };

  const kebabCase = (selected) =>
    selected
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/[\s_]+/g, '-')
      .toLowerCase();

  const initForm = () => {
    toggleActivateForm();
    toggleCompanySelector();
    const forms = dataContainer.querySelectorAll('form');
    forms.forEach((form) => {
      const formErrorMessage = form.querySelector('.form-error-message');
      let errorMessage = '';
      if (form.querySelector('[name="new_password"]')) {
        errorMessage = form.querySelector('[name="new_password"]').getAttribute('data-error-message') || '';
      }
      const fv = FormValidation.formValidation(form, {
        locale: 'sl_SI',
        localization: FormValidation.locales.sl_SI,
        fields: {
          new_password: {
            validators: {
              regexp: {
                regexp: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/g,
                message: errorMessage,
              },
            },
          },
        },
        plugins: {
          message: new FormValidation.plugins.Message({
            container: (field, element) => element.closest('.mod-input,.checkbox'),
          }),
          declarative: new FormValidation.plugins.Declarative({
            html5Input: true,
          }),
          trigger: new FormValidation.plugins.Trigger(),
          submitButton: new FormValidation.plugins.SubmitButton(),
        },
      })
        .on('core.element.validated', (e) => {
          // e.element presents the field element
          // e.valid indicates the field is valid or not

          // Get the field value
          const value = fv.getElementValue(e.field, e.element);
          const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
          FormValidation.utils.classSet(container, {
            'is-validation-failed': value === '',
          });

          FormValidation.utils.classSet(container, {
            'is-validation-failed': !e.valid,
          });
        })
        .on('core.form.valid', () => {
          const selected = form.getAttribute('id');
          const formData = {};
          form.querySelectorAll('input, textarea').forEach((input) => {
            if (input.type === 'checkbox') {
              formData[input.name] = input.checked;
            } else {
              formData[input.name] = input.value.trim();
            }
          });
          grecaptcha.ready(() => {
            grecaptcha.execute(localData.captchaSiteKey, { action: formData.action }).then((token) => {
              formErrorMessage.classList.remove('is-validation-failed');
              const action = form.querySelector(`#${kebabCase(selected)}-action`).value;
              const formDataInput = new FormData();
              formDataInput.append('action', action);
              formDataInput.append('section', kebabCase(selected));
              formDataInput.append('inputs', JSON.stringify(formData));
              formDataInput.append('lang', localData.lang);
              formDataInput.append('id', localData.id);
              formDataInput.append('token', token);
              axios
                .post(localData.siteURL, formDataInput, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                })
                .then((response) => {
                  if (response.status === 200) {
                    if (response.data.data.new_password) {
                      window.location.href = response.data.data.url;
                    } else {
                      if (selected === 'edit-profile-form') {
                        dataContainer.querySelector('[data-component="mol-edit-profile-form"]').classList.add('show-thankyou');
                        nameContainer.querySelector('.title h1').innerHTML = response.data.data.name;
                      }
                      if (selected === 'delivery-info-form') {
                        dataContainer.querySelector('[data-component="mol-delivery-info-form"]').classList.add('show-thankyou');
                      }
                      if (selected === 'help-form') {
                        dataContainer.querySelector('.help-form__header .editor-text').innerHTML = '';
                        dataContainer.querySelector('[data-component="help-form"]').classList.add('show-thankyou');
                      }
                      dataContainer.querySelector('.form-success-message').innerHTML = response.data.data.message;
                    }
                    initForm();
                  }
                })
                .catch((err) => {
                  formErrorMessage.innerHTML = err.response.data.data.msg;
                  formErrorMessage.classList.add('is-validation-failed');
                });
            });
          });
        });
      setTimeout(() => {
        initPostCodeHelper(fv, form);
      }, 200);
    });
  };

  initForm();
  toggleActivateForm();
  toggleCompanySelector();

  profileNav.querySelectorAll('a').forEach((nav) => {
    nav.addEventListener('click', (e) => {
      const selected = e.target.getAttribute('id');
      if (selected && selected !== 'wish_list') {
        e.preventDefault();
      }
      profileNav.querySelectorAll('a').forEach((clear) => {
        clear.classList.remove('is-active');
      });
      nav.classList.remove('is-active');
      e.target.classList.add('is-active');
      const formDataInput = new FormData();
      formDataInput.append('action', 'loadUserProfileSection');
      formDataInput.append('inputs', selected);
      formDataInput.append('lang', localData.lang);
      formDataInput.append('id', localData.id);
      axios
        .post(localData.siteURL, formDataInput, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            dataContainer.innerHTML = response.data.data.html;
            if (response.data.data.no_orders) {
              document.querySelector('.user-account-module').classList.add('user-account-module--no-order');
            }
            initForm();
          }
        })
        .catch((err) => {
          if (err.response.data.data.url) {
            window.location.href = err.response.data.data.url;
          }
        });
    });
  });
}
